import React, { useState } from 'react';
import { Checkbox } from '../components/ui/checkbox';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const MODULES = [
  { 
    key: 'dashboard', 
    label: 'Dashboard', 
    actions: ['view'] 
  },
  { 
    key: 'clientes', 
    label: 'Clientes', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'veiculos', 
    label: 'Veículos', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'manutencoes', 
    label: 'Manutenções', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'reservas', 
    label: 'Reservas', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'contratos', 
    label: 'Contratos', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'faturamento', 
    label: 'Faturamento', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'financeiro', 
    label: 'Financeiro', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'relatorios', 
    label: 'Relatórios', 
    actions: ['view'] 
  },
  { 
    key: 'documentos', 
    label: 'Documentos', 
    actions: ['view', 'create', 'edit', 'delete'] 
  },
  { 
    key: 'configuracoes', 
    label: 'Configurações', 
    actions: ['view', 'edit'] 
  },
  { 
    key: 'administracao', 
    label: 'Administração', 
    actions: ['view'] 
  }
];

const ACTION_LABELS = {
  view: 'Visualizar',
  create: 'Criar',
  edit: 'Editar',
  delete: 'Excluir'
};

export default function PermissionsEditor({ permissions, onChange, disabled }) {
  const handlePermissionChange = (module, action, checked) => {
    const updatedPermissions = { ...permissions };
    
    if (!updatedPermissions[module]) {
      updatedPermissions[module] = {};
    }
    
    updatedPermissions[module][action] = checked;
    onChange(updatedPermissions);
  };

  const handleModuleToggle = (module, checked) => {
    const updatedPermissions = { ...permissions };
    const moduleConfig = MODULES.find(m => m.key === module);
    
    if (!updatedPermissions[module]) {
      updatedPermissions[module] = {};
    }
    
    // Set all actions for this module
    moduleConfig.actions.forEach(action => {
      updatedPermissions[module][action] = checked;
    });
    
    onChange(updatedPermissions);
  };

  const isModuleFullyEnabled = (module) => {
    const moduleConfig = MODULES.find(m => m.key === module);
    if (!permissions[module]) return false;
    
    return moduleConfig.actions.every(action => permissions[module][action] === true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Permissões por Módulo</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {/* Header Row */}
          <div className="grid grid-cols-6 gap-4 pb-2 border-b font-medium text-sm">
            <div className="col-span-2">Módulo</div>
            <div className="text-center">Visualizar</div>
            <div className="text-center">Criar</div>
            <div className="text-center">Editar</div>
            <div className="text-center">Excluir</div>
          </div>

          {/* Permission Rows */}
          {MODULES.map((module) => (
            <div key={module.key} className="grid grid-cols-6 gap-4 items-center py-2 hover:bg-gray-50 px-2 rounded">
              <div className="col-span-2 flex items-center gap-2">
                <Checkbox
                  id={`module-${module.key}`}
                  checked={isModuleFullyEnabled(module.key)}
                  onCheckedChange={(checked) => handleModuleToggle(module.key, checked)}
                  disabled={disabled}
                />
                <Label 
                  htmlFor={`module-${module.key}`}
                  className="font-medium cursor-pointer"
                >
                  {module.label}
                </Label>
              </div>

              {/* Action Checkboxes */}
              {['view', 'create', 'edit', 'delete'].map((action) => (
                <div key={action} className="text-center">
                  {module.actions.includes(action) ? (
                    <Checkbox
                      id={`${module.key}-${action}`}
                      checked={permissions[module.key]?.[action] === true}
                      onCheckedChange={(checked) => handlePermissionChange(module.key, action, checked)}
                      disabled={disabled}
                    />
                  ) : (
                    <span className="text-gray-300">-</span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Dica:</strong> Clique no checkbox ao lado do nome do módulo para habilitar/desabilitar todas as permissões daquele módulo.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
